import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RequestPageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"request_page"}/>
}
